
module.exports = {
    getPartners,
    getProviders,
    getServices,
}

function getPartners() {
    return [
        't1envios',
        'drenvio',
        'skydropx',
        'pak2go',
        'manuable',
    ]
}

function getProviders() {
    return [
        'FedEx',
        'DHL',
        'Estafeta',
        'Sendex',
        'Paquetexpress',
        'AMPM',
        'UPS',
        '99Minutos',
    ]
}

function getServices(provider) {

    const services = {
        FedEx: [
            'Terrestre',
            'Express',
            'Express Saver',
            'Standard Overnight',
        ],
        DHL: [
            'ECONOMY SELECT DOMESTIC',
            'EXPRESS DOMESTIC',
            'EXPRESS DOMESTIC 10:30',
            'EXPRESS DOMESTIC 12:00',
        ],
        Estafeta: [
            'Express',
            'Terrestre',
        ],
        Sendex: [
            'REGULAR',
            'DIFERIDO',
        ],
        Paquetexpress: [
            'Standard',
        ],
        AMPM: [
            'Standard',
        ],
        UPS: [
            'UPS Express Saver',
            'UPS Express',
            'UPS Standard',
        ],
        '99Minutos': [
            'Next day',
            'Same day',
        ],
    }

    if (provider)
        return services[provider]

    return services
}
